const services = [
  { serviceName: "Essay", url: "/essay-services" },
  { serviceName: "Case Study", url: "/essay-services" },
  { serviceName: "Research Paper", url: "/essay-services" },
  { serviceName: "Term Paper", url: "/essay-services" },
  { serviceName: "PowerPoint Presentation", url: "/essay-services" },
  { serviceName: "Dissertation", url: "/essay-services" },
  { serviceName: "Professional Resume", url: "/essay-services" },
  { serviceName: "Scriptwriting", url: "/essay-services" },
];
export default services;
